import React, {PureComponent} from 'react';
import Select from 'react-select';
import {Input} from '..';
import {PdfSizes} from 'modules';
import { Radio } from 'material-ui';
import intl from 'react-intl-universal';

import styles from './styles';

const resizeOptions = [
  { value: 'pixels', label: 'pixels' },
  { value: 'millimeters', label: 'millimeters' },
  { value: 'centimeters', label: 'centimeters' },
  { value: 'inches', label: 'inches' },
  { value: 'points', label: 'points' }
];
const numberInputProps = {
  border: true,
  type: 'number',
  min: '1',
  step: '1',
  style: {
    margin: '10px 0'
  }
};
const marginStyle = {
  style: {
    margin: '10px 0'
  }
};

function getFloat(num) {
  const parsed = parseFloat(num);

  return isNaN(parsed) ? 0 : parsed;
}

export default class PdfResizer extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      size: 100,
      suffix: 'millimeters',
      resizeType: 'predefined',
      customWidth: 0,
      customSuffix: 'pixels',
      customHeight: 0,
    };
  }

  onChangeSize = ({ value }) => this.setState({ resizeType: 'predefined', size: value });
  onChangeSuffix = ({ value }) => this.setState({ resizeType: 'custom', suffix: value });
  onChangeType = ({ currentTarget }) => this.setState({ resizeType: currentTarget.value });

  onChangeWidth = (width) => this.setState({
    resizeType: 'custom',
    customWidth: getFloat(width)
  });

  onChangeHeight = (height) => this.setState({
    resizeType: 'custom', 
    customHeight: getFloat(height)
  });

  componentDidUpdate() {
    const {onOptionChange} = this.props;

    let size;
    if(this.state.resizeType==='custom'){
      size = {
        'type': 'custom',
        'width': this.state.customWidth,
        'height': this.state.customHeight,
        'suffix': this.state.suffix
      }
    } else {
      size = {
        'type': 'predefined',
        'size': this.state.size
      }
    }

    onOptionChange({size});
  }

  renderCustomOptions() {
    const {customWidth, customHeight, suffix} = this.state;
    if(this.state.resizeType==='custom'){

    // If custom options are desired, we show some more fields
      return (
        <div className={styles.sideBySideInputs}>
            <div className={styles.oneThird}>
            <label> {intl.get('Width')}</label>
              <Input
                value={customWidth}
                onChange={this.onChangeWidth}
                {...numberInputProps}
              />
            </div>
            <div className={styles.oneThird}>
            <label> {intl.get('Height')} </label>
              <Input
                value={customHeight}
                onChange={this.onChangeHeight}
                {...numberInputProps}
              />
           </div>
            <div className={styles.oneThird}>
            <label> {intl.get('Lable')} </label>
              <Select
                value={suffix}
                options={resizeOptions}
                onChange={this.onChangeSuffix}
                {...marginStyle}
                clearable={false}
              />
            </div>
        </div>
    );
}
    // return null;
  }
  render() {
    const {size, resizeType} = this.state;

    const sizeOptions = PdfSizes.getSizes(intl);
    
    return (
      <div>
        <div className=''>
          <label>
            <Radio name="resize-type" value="predefined"
                checked={resizeType === 'predefined'} 
                onChange={this.onChangeType} />&nbsp;
            {intl.get('Resize By page Size')}
          </label>
          <div className='section'>
          <Select
            className={styles.halfWidth}
            name='imageSize'
            value={size}
            options={sizeOptions}
            onChange={this.onChangeSize}
            clearable={false}
          />
          </div>
        </div>
        <div className=''>
            <label>
              <Radio name="resize-type" value="custom" 
                checked={resizeType === 'custom'} 
                onChange={this.onChangeType} />&nbsp;
              {intl.get('Custom page Size')}
            </label>
          </div>
          <div className='section'>
            {this.renderCustomOptions()}
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PdfResizer/index.jsx